<template>
  <v-container class="content ma2">
    <div data-aos="fadeInUp">
      <div class="display-2 text--center">OUR TRUCK</div>
      <div class="grey--text subheading">The braun of the operation</div>
    </div>

    <blockquote class="blockquote">We chose the RIVAL T7 because of its size and weight advantages. It can fit into areas that tend to be more difficult for larger Hydrovac trucks. Its supior design offers a clear advantage in the Hydrovac industry.</blockquote>
    <v-layout row wrap data-aos="fadeInUp">
      <v-flex xs12 md6>
        <v-card class="ma-2">
          <v-card-title primary-title>
            <div>
              <h3 class="headline mb-0">TRUCK DETAILS</h3>
            </div>
          </v-card-title>

          <v-card-text>
            <span class="subheading">
              
              <v-chip color="orange" text-color="white">
                Our New RIVAL T7
                <v-icon right>local_shipping</v-icon>
              </v-chip>
            </span>
            <p>From Rivalhydrovac.com</p>
            <div class="subheading mt-3">LIGHTWEIGHT</div>
            <div class="body-1">The Rival truck was created to allow for business owners and their employees to be able to provide highly efficient Hydrovac services within the constraints of the law.</div>
            <div class="subheading mt-3">SAFETY FOCUS</div>
            <div class="body-1">Dual backup cameras, top of truck retractable safety railing, boom sensors and even more advantages for operators so they can drive, load and empty the truck safely.</div>
          
          <div class="subheading mt-3">SUPERIOR DESIGN</div>
          <div class="body-1">The Rival unit was engineered from the ground up by a seasoned licensed engineer. This process took a full year and over 3000 man hours. Every detail was attended to at a level unusual to these trucks.</div>
          <div class="subheading mt-3">EFFICIENT</div>
<div class="body-1">Each unit has an automatic transmission. These trucks will hoist to dump and are equipped to pressure off a flow able load to another tank, truck or trailer.</div>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs12 md6>
        <v-card class="ma-2">
          <v-card-title primary-title>
            <div>
              <h3 class="headline mb-0">RIVAL HYDROVAC YOUTUBE VIDEO</h3>
            </div>
          </v-card-title>

          <v-card-text>
            <span>Check out the promo video from Rival Hydrovac.</span>
            <a href="http://youtu.be/xJ-tYmYYSnQ" target="_blank"></a>
            <v-btn
              color="blue-grey"
              class="white--text"
              href="http://youtu.be/xJ-tYmYYSnQ"
              target="_blank"
            >
              YOUTUBE
              <v-icon right dark>fab fa-youtube</v-icon>
            </v-btn>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {};
</script>

<style scoped>
</style>